import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck, ShieldX } from "lucide-react";
import { PageHero, Section } from "../components/PageKit";
import api from "../lib/api";
import { usePageMeta } from "../lib/seo";

// Public QR landing: confirms whether a membership card is genuine and active.
export default function CardVerify() {
  const { cardNo } = useParams();
  const [r, setR] = useState(null);
  usePageMeta(`Verify card ${cardNo} | Dutsen Kauna Foundation`, "Check that a Dutsen Kauna Foundation membership ID card is genuine.");
  useEffect(() => { api.get(`/cards/verify/${cardNo}`).then((x) => setR(x.data)).catch(() => setR({ valid: false })); }, [cardNo]);
  return (
    <div data-testid="card-verify-page">
      <PageHero kicker="Card verification" title="Membership ID card check" text="Every Dutsen Kauna Foundation card carries a QR code that leads here. If the details below do not match the card in front of you, do not trust it." />
      <Section>
        <div className="max-w-md mx-auto bg-white rounded-2xl border border-black/5 p-8 text-center">
          {!r && <p className="text-sm">Checking…</p>}
          {r && (r.valid ? <ShieldCheck size={48} className="mx-auto text-green-700" /> : <ShieldX size={48} className="mx-auto text-red-700" />)}
          {r && <h2 className="font-serif text-2xl font-bold mt-3" data-testid="card-verify-result">{r.valid ? "Genuine, active card" : r.status === "revoked" ? "This card has been revoked" : "Card not recognised"}</h2>}
          {r?.valid && <div className="text-sm mt-3 space-y-1"><p><b>{r.full_name}</b></p><p className="text-[#0a0d12]/70">{r.subtitle}</p><p className="font-mono text-xs">{r.card_no}</p><p className="text-xs text-[#0a0d12]/60">{r.member_type} · member since {r.member_since}</p></div>}
          <p className="text-xs text-[#0a0d12]/60 mt-5">A membership card never authorises anyone to collect money on the Foundation's behalf. Report misuse to foundation@dutsenkauna.org.</p>
        </div>
      </Section>
    </div>
  );
}
